<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }"
        >个人中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="create_order">
      <div class="order_body">
        <el-form ref="dataForm" label-width="90px" label-position="right">
          <!-- 客户信息 -->
          <el-row class="basic-panel basic-panel-customer">
            <h1 class="panel-title">客户信息：</h1>
            <el-col :span="12">
              <el-form-item label="客户名称：">{{
                $store.state.user.defaultCompanyName || "-"
              }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发起人：">{{
                $store.state.user.name || "-"
              }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="需求备注：">
                <el-input
                  type="textarea"
                  :placeholder="$t('stockNeed.enterRemark')"
                  v-model="remark"
                  clearable
                  maxlength="300"
                  :rows="2"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 需求明细 -->
          <el-row class="basic-panel basic-panel-product">
            <h1 class="panel-title">需求明细：</h1>
            <div class="product-box">
              <el-table
                ref="goodsTable"
                size="small"
                :data="goodsList"
                :header-cell-style="{ background: '#f9f9f9' }"
                style="width: 100%"
                border
              >
                <el-table-column
                  type="index"
                  width="50"
                  :label="$t('product.id')"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="spuCode"
                  header-align="center"
                  align="center"
                  label="订货号"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="spuName"
                  header-align="center"
                  align="center"
                  :label="$t('ordervote.productName')"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="brandName"
                  header-align="center"
                  align="center"
                  :label="$t('common.brand')"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="seriesName"
                  header-align="center"
                  align="center"
                  :label="$t('common.collection')"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="model"
                  :label="$t('common.model')"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.model || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="attributeInfoList"
                  header-align="center"
                  align="center"
                  label="详细参数"
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <template
                      v-if="!scope.row.attributeInfoList[0].canEditDeep"
                    >
                      {{ filterAttribute(scope.row.attributeInfoList) || "-" }}
                    </template>

                    <template
                      v-if="
                        scope.row.editableDeep &&
                        !scope.row.attributeInfoList[0].canEditDeep
                      "
                    >
                      <el-button
                        v-if="scope.row.editableDeep"
                        size="mini"
                        type="text"
                        icon="el-icon-edit"
                        @click="openEdit(scope.row.attributeInfoList[0])"
                      ></el-button>
                    </template>
                    <template v-else-if="scope.row.editableDeep">
                      {{ scope.row.attributeInfoList[0].attributeItemName }}:
                      <div>
                        <el-input
                          size="small"
                          maxlength="255"
                          placeholder="手动录入"
                          style="width: calc(100% - 40px)"
                          v-model.trim="
                            scope.row.attributeInfoList[0].tempValueDeep
                          "
                        />
                        <el-button
                          size="mini"
                          type="text"
                          icon="el-icon-check"
                          @click="
                            editManualMatch(scope.row.attributeInfoList[0], scope.row)
                          "
                        ></el-button>
                        <el-button
                          size="mini"
                          type="text"
                          icon="el-icon-close"
                          @click="
                            scope.row.attributeInfoList[0].canEditDeep = false
                          "
                        ></el-button>
                      </div>
                    </template>
                    <InfoIcon
                      v-if="
                        scope.row.attributeInfoList &&
                        scope.row.attributeInfoList.length &&
                        scope.row.attributeInfoList.length > 1
                      "
                      :manualAttributeValueList="
                        scope.row.manualAttributeValueList
                      "
                      :editable="true"
                      :row="scope.row.attributeInfoList"
                      @updateModel="generateModel(scope.row)"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="moq"
                  header-align="center"
                  align="center"
                  label="最小起订量"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="recordRemark"
                  header-align="center"
                  align="center"
                  label="需求备注"
                  width="200px"
                >
                  <template slot-scope="scope">
                    <el-input
                      type="textarea"
                      :placeholder="$t('stockNeed.enterRemark')"
                      v-model="scope.row.recordRemark"
                      clearable
                      maxlength="300"
                      :rows="2"
                      resize="none"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="number"
                  header-align="center"
                  align="center"
                  label="需求数量"
                  width="125px"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      placement="top"
                      :content="`起订量${scope.row.moq || 1}, 步长${
                        scope.row.sellingUnitStepSize || 1
                      }`"
                    >
                      <span>
                        <el-input-number
                          style="width: 100px"
                          controls-position="right"
                          v-model="scope.row.number"
                          :precision="0"
                          :min="1"
                          :max="999999999"
                          :step="scope.row.sellingUnitStepSize || 1"
                          @change="
                            (currentValue, oldValue) =>
                              changeAmount(
                                currentValue,
                                oldValue || 0,
                                scope.row,
                                scope.$index
                              )
                          "
                        ></el-input-number>
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed="right"
                  header-align="center"
                  align="center"
                  :label="$t('handle')"
                  width="60px"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="deleteHandle(scope.row, scope.$index)"
                      >{{ $t("delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-row>
          <!-- 提交询价 -->
          <el-row class="basic-panel">
            <el-col :span="24">
              <div class="order-submit">
                <button :loading="buttonLoading" @click.prevent="submit">
                  提交询价
                </button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import InfoIcon from './components/infoIcon.vue'
export default {
  name: 'selectionInquiryCreate',
  components: {
    InfoIcon
  },
  data () {
    return {
      inquiryInfo: null,
      itemIdList: [],
      createFrom: 0,
      goodsList: [],
      buttonLoading: false,
      remark: ''
    }
  },
  mounted () {
    if (this.$route.query.inquiryInfo) {
      // 从详情页‘立即询价’跳转
      this.inquiryInfo = JSON.parse(this.$route.query.inquiryInfo)
      this.createFrom = 0
    } else if (this.$route.query.shoppingCartFormList) {
      // 从购物车跳转
      this.itemIdList = JSON.parse(this.$route.query.shoppingCartFormList)
      this.createFrom = 1
    }
    this.generateTempList()
  },
  methods: {
    generateTempList () {
      let params = {}
      if (this.createFrom === 0) {
        params = { ...this.inquiryInfo }
      } else if (this.createFrom === 1) {
        params = {
          itemIdList: [...this.itemIdList]
        }
      }
      this.$http
        .post(
          `/front/commodity/manager/lectotypeInquiry/generateTempList`,
          params
        )
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.goodsList = res.data || []
          // 如果只有一条数据,需要判断是不是手动录入的数据
          this.goodsList.forEach((item) => {
            if (item.attributeInfoList.length === 1) {
              item.attributeInfoList.forEach((infoItem) => {
                // 是否为可编辑状态
                this.$set(infoItem, 'canEditDeep', false)
                // 赋值一个暂存字段
                this.$set(infoItem, 'tempValueDeep', item.attributeValueName)
                // 是否出现编辑按钮,根据他有没有手动录入的属性值id匹配
                if (
                  item.manualAttributeValueList.find(
                    (zitem) =>
                      zitem.manualAttributeValueId === infoItem.attributeValueId
                  )
                ) {
                  this.$set(item, 'editableDeep', true)
                } else {
                  this.$set(item, 'editableDeep', false)
                }
              })
            } else {
              this.$set(item, 'editableDeep', false)
            }
          })
        })
    },
    // 打开手动录入编辑
    openEdit (row) {
      row.tempValueDeep = row.attributeValueName
      row.canEditDeep = true
    },
    editManualMatch (row, realRow) {
      if (!row.tempValueDeep) {
        this.$message.warning('请输入')
        return
      }
      row.attributeValueName = row.tempValueDeep
      row.canEditDeep = false
      this.generateModel(realRow)
    },
    // 修改步长
    changeAmount (currentValue, oldValue, val, index) {
      const value = this.goodsList[index]
      if (
        value.sellingUnitStepSize &&
        currentValue % value.sellingUnitStepSize !== 0
      ) {
        const num =
          currentValue > oldValue
            ? -(currentValue % value.sellingUnitStepSize)
            : value.sellingUnitStepSize -
              (currentValue % value.sellingUnitStepSize)
        if (num !== 0) {
          this.$nextTick(() => {
            this.$set(this.goodsList[index], 'number', currentValue + num)
          })
        }
      }
    },
    // 删行
    deleteHandle (row, index) {
      this.goodsList.splice(index, 1)
    },
    // 生成型号参数
    generateModel (row) {
      row.manualAttributeValueList = row.manualAttributeValueList.map(
        (manualItem) => {
          // 匹配对应属性
          const result = row.attributeInfoList.find(
            (attrItem) =>
              attrItem.attributeValueId === manualItem.manualAttributeValueId
          )
          return {
            manualAttributeValue:
                (result && result.attributeValueName) ||
                manualItem.manualAttributeValue,
            manualAttributeValueId: manualItem.manualAttributeValueId
          }
        }
      )
      this.$http
        .post(`/front/cross/commodity/manager/lectotypeSpu/getModelByAttributeInfo`, {
          spuId: row.spuId,
          attributeValueIds: row.attributeValueIds,
          manualAttributeValueList: row.manualAttributeValueList
        }).then(({ data: res }) => {
          if (res.code === 0) {
            if ('model' in row) {
              row.model = res.data || ''
            } else {
              this.$set(row, 'model', res.data || '')
            }
          }
        })
    },
    submit () {
      if (!this.goodsList) {
        return this.$message.warning('无可提交需求')
      }
      const recordList = []
      let flag = false
      let flagList = []
      this.goodsList.forEach((item, index) => {
        item.manualAttributeValueList = item.manualAttributeValueList.map(
          (manualItem) => {
            // 匹配对应属性
            const result = item.attributeInfoList.find(
              (attrItem) =>
                attrItem.attributeValueId === manualItem.manualAttributeValueId
            )
            return {
              manualAttributeValue:
                (result && result.attributeValueName) ||
                manualItem.manualAttributeValue,
              manualAttributeValueId: manualItem.manualAttributeValueId
            }
          }
        )
        recordList.push({
          attributeValueIds: item.attributeValueIds,
          manualAttributeValueList: item.manualAttributeValueList,
          number: item.number,
          model: item.model,
          recordRemark: item.recordRemark,
          spuId: item.spuId
        })
        // 步长/起订量检验
        let { sellingUnitStepSize, spuName, moq } = item
        !moq && (moq = 1)
        !sellingUnitStepSize && (sellingUnitStepSize = 1)
        if (item.number < +moq || item.number % sellingUnitStepSize !== 0) {
          flag = true
          flagList.push(
            `${
              this.createFrom === 0 ? '' : `第${index + 1}行`
            }【${spuName}】起订量为${
              moq || 1
            }，步长为${sellingUnitStepSize}，请输入大于${
              moq || 1
            }且${sellingUnitStepSize}的倍数！`
          )
        }
      })
      // 起订量校验
      if (flag && flagList.length) {
        this.$message.warning({
          dangerouslyUseHTMLString: true,
          message: flagList.join('<br>')
        })
        return
      }

      if (this.buttonLoading) return false
      this.buttonLoading = true

      const params = {
        recordList,
        remark: this.remark
      }
      if (this.createFrom === 1) params.itemIdList = this.itemIdList
      this.$http
        .post(`front/commodity/manager/lectotypeInquiry/saveInquiry`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(this.$t('message.addSuccess'))
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$router.push({ name: 'selectionCategoryList' })
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    // 筛选出一条属性
    filterAttribute (attrList) {
      if (attrList && attrList.length) {
        return `${attrList[0].attributeItemName}: ${attrList[0].attributeValueName}`
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.create_order {
  background: #fff;
  padding: 30px 0;
  .order_body {
    width: 1136px;
    margin: 0 auto;
    .basic-panel {
      margin-bottom: 20px;
      .panel-title {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
      }
      .addBtn-box {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #3d88d4;
        float: right;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
          display: block;
          float: left;
          margin: 2px 6px;
        }
      }

      .pay-box {
        .el-radio {
          width: 148px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border: 1px solid #ddd;
          /deep/.el-radio__input {
            display: none;
          }
          &.is-checked {
            position: relative;
            border-color: #3d88d4;
            &:after {
              content: "";
              display: block;
              height: 47px;
              width: 47px;
              background-image: url("./../../../assets/img/order/checkIcon.png");
              background-size: 100%;
              position: absolute;
              right: -21px;
              bottom: -20px;
            }
          }
          /deep/.el-radio__input.is-checked + .el-radio__label {
            color: #333 !important;
          }
          /deep/.el-radio__input.is-checked .el-radio__inner {
            background: #333 !important;
            border-color: #333 !important;
          }
        }
      }
      .order-submit {
        background-color: #eee;
        overflow: hidden;
        .change-box {
          float: right;
          text-align: right;
          margin: 25px 80px 0 0;
          p {
            line-height: 30px;
            margin: 0;
            big {
              font-size: 16px;
              color: #ff3636;
            }
          }
        }
        button {
          background: #ff3636;
          width: 182px;
          height: 80px;
          line-height: 80px;
          border: none;
          color: #fff;
          cursor: pointer;
          float: right;
        }
      }
    }
    .basic-panel-customer {
      .el-form-item {
        margin-bottom: 10px;
      }
    }
    .basic-panel-bill {
      >>> .el-tabs--card > .el-tabs__header {
        border-bottom: none;
        .el-tabs__nav {
          border: none;
        }
      }
      >>> .el-tabs__item {
        width: 148px;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
        border: 1px solid #ddd;
        margin-right: 16px;
        &.is-active {
          background-color: #e5f0ff;
          color: #333;
          border-color: #3d88d4;
        }
      }
    }
  }
}
</style>
